// src/admin/components/GeminiModelField.jsx
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

// Dropdown fed by the live Gemini model list; freeSolo keeps manual entry
// working when the listing fails or the saved model is no longer offered.
export default function GeminiModelField({ label, value, onChange, models, defaultId }) {
  const ids = (models || []).map((m) => m.id);
  const unavailable = models && value && !ids.includes(value);
  return (
    <Autocomplete
      freeSolo
      options={ids}
      value={value}
      onInputChange={(_, v) => onChange(v)}
      renderOption={(props, id) => (
        <li {...props} key={id}>{id === defaultId ? `${id} (standard)` : id}</li>
      )}
      renderInput={(params) => (
        <TextField {...params} margin="normal" label={label}
          error={!!unavailable}
          helperText={unavailable
            ? 'Modello non presente nella lista attuale di Gemini: verifica prima di salvare'
            : models ? 'Scegli dalla lista dei modelli disponibili' : "Lista modelli non disponibile: digita l'ID"} />
      )}
    />
  );
}
